export { NavigationMenu, type NavigationMenuProps } from "./NavigationMenu";
